import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import EditorPage from './pages/EditorPage';
import PreviewPage from './pages/PreviewPage';
import './App.css';
import AdminPage from './pages/AdminPage';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/web-builder" element={<EditorPage />} />
          <Route path="/preview" element={<PreviewPage />} />
          <Route path="/preview/:websiteId" element={<PreviewPage />} />
          <Route path="/preview/:websiteId/:type" element={<PreviewPage />} />
          <Route path="/admin" element={<AdminPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
